import { NgModule } from '@angular/core';
import { BaseModule } from '../../shared/base.module';

import { MeAppointmentComponent } from './appointment.component';
import { MeAppointmentRoutesModule } from './appointment.routes';
import { MeAppointmentBookedCardComponent } from './booked-card/booked-card.component';
import { MeAppointmentBookingCardComponent } from './booking-card/booking-card.component';
import { MeAppointmentBookingPageComponent } from './booking-page/booking-page.component';
import { DialogModule } from '../../dialog/dialog.module';

@NgModule({
    imports: [
        BaseModule,
        DialogModule,
        MeAppointmentRoutesModule
    ],
    declarations: [
        MeAppointmentComponent,
        MeAppointmentBookingPageComponent,
        MeAppointmentBookingCardComponent,
        MeAppointmentBookedCardComponent
    ],
    exports: [
        MeAppointmentComponent,
        MeAppointmentBookingPageComponent,
        MeAppointmentBookingCardComponent,
        MeAppointmentBookedCardComponent
    ]
})

export class MeAppointmentModule { }
